import classnames from "classnames";
import Footer from "../../components/common/Footer/Footer";
import Header from "../../components/common/Header/Header";
import ContactUs from "../../components/common/ContactUs/ContactUs";
import classes from "../../styles/Resources.module.scss";
import Banner from "../../components/common/Banner/Banner";
import BannerType from "../../global/banner-type";
import resources from "../../assets/images/resources.png";
import { ourSolution } from "../../global/constant";
import { nanoid } from "nanoid";
import RealEstate from "./components/RealEstate";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_PATH } from "../../routes/route";
import Education from "./components/Education";
import DTHEntertainment from "./components/DTHEntertainment";
import Retail from "./components/Retail";
import Hospitality from "./components/Hospitality";
import BFSI from "./components/BFSI";
import useIsMobile from "../../components/hooks/useIsMobile";

const OurSolutionsPage = ({ page = "oursolutions" }) => {
  const isMobile = useIsMobile({ breakpoint: 992 });
  const [activeTab, setActiveTab] = useState(page);
  const navigate = useNavigate();
  const handleClick = para => {
    setActiveTab(para);
    if (para !== "") {
      navigate(`${APP_PATH}/oursolutions/${para}`);
    } else {
      navigate(`${APP_PATH}/oursolutions`);
    }
  };
  return (
    <>
      <Header
        page={
          activeTab === "oursolutions" ? activeTab : `oursolutions/${activeTab}`
        }
      />
      <div
        className={classnames("container containerWidth", classes.container)}
      >
        <div className="minheightCont100vh">
          <div className={classnames(classes.sidebar)}>
            <div
              className={classnames(classes.heading)}
              onClick={() => handleClick("")}
            >
              Our solution
            </div>
            <ul className={classnames(classes.menuList)}>
              {ourSolution.map(tab => {
                return (
                  <li
                    className={`${activeTab === tab.id ? classes.active : ""}`}
                    onClick={() => handleClick(tab.id)}
                    key={nanoid()}
                  >
                    {tab.title}
                  </li>
                );
              })}
            </ul>
          </div>
          {(() => {
            switch (activeTab.toLowerCase()) {
              case "realestate":
                return <RealEstate />;
              case "contactus":
                return <ContactUs classname={classes.contactUs} />;
              case "education":
                return <Education />;
              case "retail":
                return <Retail />;
              case "hospitality":
                return <Hospitality />;
              case "bfsi":
                return <BFSI />;
              case "dthentertainment":
                return <DTHEntertainment />;
              default:
                return <OurSolutions callbackfnc={handleClick} />;
            }
          })()}
        </div>
        {!isMobile && <Footer className={classes.footerClass} />}
      </div>
      {isMobile && <Footer />}
    </>
  );
};

const OurSolutions = ({ callbackfnc }) => {
  return (
    <div className={classnames(classes.main_content)}>
      <div className={classnames(classes.bannerSection)}>
        <Banner
          type={BannerType.SINGLE_IMAGE_BANNER}
          title="Our solutions"
          description="Align our result-driven Enterprise Solutions with your marketing objectives."
          image={resources}
          maxWidth={214}
          className={classes.containerWidth}
        />
      </div>
      <div className={classnames(classes.grid_box)}>
        {ourSolution.map(solution => {
          return (
            <div key={nanoid()} onClick={() => callbackfnc(solution.id)}>
              <Banner type={BannerType.SIMPLE_BANNER} {...solution} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OurSolutionsPage;
